/* unplugin-vue-components disabled */import { render } from "./system.vue?vue&type=template&id=01564730"
import script from "./system.vue?vue&type=script&lang=js"
export * from "./system.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/settings/superuser/system.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01564730"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01564730', __exports__)) {
    api.reload('01564730', __exports__)
  }
  
  module.hot.accept("./system.vue?vue&type=template&id=01564730", () => {
    api.rerender('01564730', render)
  })

}


export default __exports__